import React, { useContext, useEffect } from 'react';
import { useLocation } from 'react-router';

import MainLoader from '../components/Loader';
import useGenerateAuthToken from '../hooks/useGenerateAuthToken';
import { AuthenticationContext } from '../providers/AuthenticationProvider';
import { generateRedirectPayload, isEnterprise, isPR } from '../utils/loginUtils';

const EnterpriseLoginPage = () => {
  const { data: authTokenData } = useGenerateAuthToken();
  const { state } = useLocation<{ from?: string } | undefined>();
  const stateLoginParam =
    authTokenData?.token && state?.from
      ? generateRedirectPayload(authTokenData?.token, state.from)
      : authTokenData?.token
      ? authTokenData?.token
      : undefined;

  const authService = useContext(AuthenticationContext);

  useEffect(() => {
    if (authService && stateLoginParam && authTokenData) {
      const request = {
        state: stateLoginParam,
        scopes: ['openid', 'profile'],
        extraQueryParameters: {
          ui_locales: 'en',
          appOrigin: authTokenData?.token,
        },
      };
      authService?.login(request);
    }
  }, [authService, authTokenData, stateLoginParam]);

  return <MainLoader />;
};

const SelfServeLoginPage = () => {
  return <LoginPage />;
};

const LoginPage = () => {
  const authService = useContext(AuthenticationContext);
  const { state } = useLocation<{ from?: string } | undefined>();

  useEffect(() => {
    if (authService) {
      const request = {
        state: state?.from ? generateRedirectPayload('', state.from) : undefined,
        scopes: ['openid', 'profile'],
        extraQueryParameters: {
          ui_locales: 'en',
        },
      };
      authService?.login(request);
    }
  }, [authService, state]);

  return <MainLoader />;
};
export default isEnterprise() || isPR() ? EnterpriseLoginPage : SelfServeLoginPage;
